import Splide from '@splidejs/splide';

export default (config = {}) => ({
  enableLightbox: config.enableLightbox ?? true,
  lightboxCaption: config.lightboxCaption ?? 'Galeria zdjęć',
  lightboxOpen: false,
  currentIndex: 0,
  currentImage: { url: '', alt: '', caption: '' },
  images: config.galleryImages ?? [],
  sliders: [],

  init() {
    const splideElements = this.$el.querySelectorAll('.splide');

    if (splideElements.length > 0) {
      splideElements.forEach(element => {
        const customOptions = element.dataset.splide ? JSON.parse(element.dataset.splide) : {};
        const splide = new Splide(element, {
          type: 'slide',
          pagination: true,
          arrows: true,
          gap: '1rem',
          ...customOptions
        });

        splide.mount();
        this.sliders.push(splide);
      });
    }

    this.$watch('lightboxOpen', (value) => {
      if (value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', this.handleKeydown.bind(this));
  },

  openLightbox(index) {
    if (!this.enableLightbox) return;

    this.currentIndex = index;
    this.updateCurrentImage();
    this.lightboxOpen = true;
  },

  closeLightbox() {
    this.lightboxOpen = false;
  },

  nextImage() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.updateCurrentImage();
    }
  },

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCurrentImage();
    }
  },

  updateCurrentImage() {
    if (this.images[this.currentIndex]) {
      this.currentImage = this.images[this.currentIndex];
    }
  },

  handleKeydown(event) {
    if (!this.lightboxOpen) return;

    switch (event.key) {
      case 'ArrowRight':
        this.nextImage();
        break;
      case 'ArrowLeft':
        this.prevImage();
        break;
      case 'Escape':
        this.closeLightbox();
        break;
    }
  }
});
